const DEFAULT_MOVEMENTS = [
  "feeder_to_pre",
  "pre_to_manager",
  "manager_to_verificator",
  "verificator_to_editor",
  "editor_to_verificator",
  "verificator_to_manager",
  "manager_to_pre"
].join("|");

const CONFIG_STATE_BY_MODULE = {
  technology: "flowAssignmentRevealTechnology",
  alternative: "flowAssignmentRevealAlternative",
  experience: "flowAssignmentRevealExperience",
  innovation: "flowAssignmentRevealInnovation",
  assistance: "flowAssignmentRevealAssistance",
  financial: "flowAssignmentRevealFinancial",
  vision: "flowAssignmentRevealVision",
  regulation: "flowAssignmentRevealRegulation"
};

const MOVEMENT_FROM_PRESENTATION = {
  "send:pre-manager": "feeder_to_pre",
  "send:manager": "pre_to_manager",
  "send:verificator": "manager_to_verificator",
  "send:validator": "manager_to_verificator",
  "send:editor": "verificator_to_editor",
  "return:verificator": "editor_to_verificator",
  "return:validator": "editor_to_verificator",
  "return:manager": "verificator_to_manager",
  "return:pre-manager": "manager_to_pre"
};

export const getRevealValueForModule = (configuration = {}, moduleProcess = "") => {
  const key = CONFIG_STATE_BY_MODULE[String(moduleProcess || "").trim().toLowerCase()];
  if (!key) {
    return DEFAULT_MOVEMENTS;
  }
  const value = configuration[key];
  return value == null ? DEFAULT_MOVEMENTS : String(value);
};

export const movementKeyFromPresentation = (presentation = {}) => {
  const direction = String(presentation.direction || "send").trim().toLowerCase();
  const toRole = String(presentation.to_role_key || "").trim().toLowerCase();
  return MOVEMENT_FROM_PRESENTATION[`${direction}:${toRole}`] || "";
};

export const shouldRevealAssignee = (configuration, moduleProcess, presentation = {}) => {
  const allowed = String(getRevealValueForModule(configuration, moduleProcess) || "")
    .split("|")
    .map((item) => item.trim())
    .filter(Boolean);
  if (!allowed.length) {
    return false;
  }
  const movement = movementKeyFromPresentation(presentation);
  return Boolean(movement && allowed.includes(movement));
};

const hasAssignmentCode = (code) => {
  const value = String(code || "").trim();
  return Boolean(value) && value !== "—";
};

export const formatAssignmentLine = ({
  id,
  code,
  name,
  usePool,
  t,
  subjectKind = "",
  areaKey = ""
}) => {
  const caseId = id || "—";
  const caseCode = String(code || "").trim();
  const personName = name || t("flow.assignment.person-unknown", "una persona");
  const mark = String(areaKey || "").trim();
  if (subjectKind === "search_key_term") {
    if (usePool) {
      if (!mark) {
        return t(
          "flow.assignment.destination.term.poolNoMark",
          "El Término Clave id: {{id}}, se asignará al mostrador (pool).",
          { id: caseId }
        );
      }
      return t(
        "flow.assignment.destination.term.pool",
        "El Término Clave id: {{id}}, {{mark}}, se asignará al mostrador (pool).",
        { id: caseId, mark }
      );
    }
    if (!mark) {
      return t(
        "flow.assignment.destination.term.personNoMark",
        "El Término Clave id: {{id}}, se asignará a: {{name}}",
        { id: caseId, name: personName }
      );
    }
    return t(
      "flow.assignment.destination.term.person",
      "El Término Clave id: {{id}}, {{mark}}, se asignará a: {{name}}",
      { id: caseId, mark, name: personName }
    );
  }
  if (usePool) {
    if (!hasAssignmentCode(caseCode)) {
      return t(
        "flow.assignment.destination.pool.detailNoCode",
        "El caso id:{{id}}, se asignará al mostrador (pool).",
        { id: caseId }
      );
    }
    return t(
      "flow.assignment.destination.pool.detail",
      "El caso id:{{id}}, codigo:{{code}}, se asignará al mostrador (pool).",
      { id: caseId, code: caseCode }
    );
  }
  if (!hasAssignmentCode(caseCode)) {
    return t(
      "flow.assignment.destination.person.detailNoCode",
      "El caso id:{{id}}, se asignará a : {{name}}",
      { id: caseId, name: personName }
    );
  }
  return t(
    "flow.assignment.destination.person.detail",
    "El caso id:{{id}}, codigo:{{code}}, se asignará a : {{name}}",
    { id: caseId, code: caseCode, name: personName }
  );
};
